import type { ReactNode } from "react";

interface FeaturesRootProps {
  children: Readonly<ReactNode>;
}

export default function FeaturesRoot({ children }: FeaturesRootProps) {
  return (
    <section className="relative z-20 max-w-5xl container mx-auto flex flex-col gap-5 px-4 my-12">
        {children}
    </section>
  );
}
